import axios from '@fs/zion-axios'

const BASE_CTR_PATH = '/service/dmc/ctr'

export function getCtr(cid) {
  return axios.get(`${BASE_CTR_PATH}/${cid}`, { dontSpin: true })
}

export async function getCtrSummary(cid) {
  if (cid) {
    const response = await axios.get(`${BASE_CTR_PATH}/${cid}/summary`)
    return response
  }
  return null
}

export async function getCtrChanges(cid) {
  if (cid) {
    const response = await axios.get(`${BASE_CTR_PATH}/${cid}/changes`)
    return response
  }
  return null
}

export async function putCtr(ctrEditRequest) {
  return axios.put(`${BASE_CTR_PATH}/${ctrEditRequest.templePlatform.ctrs[0].id}/update`, ctrEditRequest)
}
